import { css } from '@emotion/core';
import { Headline3 } from '@nexus/lib-react/dist/core/Typography/Heading';
import { Paragraph4 } from '@nexus/lib-react/dist/core/Typography/Paragraph';
import styled from '@olxeu-a2b/ui/src/theme/styled';

const mq = {
  tablet: '@media (min-width: 768px) and (max-width: 1024px)',
  desktop: '@media (min-width: 1024px)',
  desktopLarge: '@media (min-width: 1366px)',
};

interface BenefitItemContainer {
  selected: boolean;
}

const PageWrapper = styled.div`
  ${({ theme }) =>
    css`
      background-color: ${theme.colors.grey2};
      color: ${theme.colors['text-brand-primary']};
      padding: 80px 16px 20px;
    `}
`;

const InfoBlock = styled.div`
  margin: 0 auto;
  text-align: center;
  max-width: 830px;
`;

const PageTitle = styled(Headline3)`
  font-size: 24px;
  line-height: 26px;
  font-weight: ${({ theme }) => theme.fontWeights['600']};

  ${mq.tablet} {
    font-size: 32px;
    line-height: 38px;
  }

  ${mq.desktop} {
    font-size: 40px;
    line-height: 38px;
  }
`;

const PageDescription = styled(Headline3)`
  font-weight: normal;
  margin-top: 16px;
  font-size: 14px;
  line-height: 18px;

  ${mq.tablet} {
    font-size: 20px;
    line-height: 22px;
  }

  ${mq.desktop} {
    font-size: 24px;
    line-height: 22px;
    margin-top: 32px;
  }
`;

const BenefitsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 32px 0;
  justify-content: center;

  ${mq.desktop} {
    margin-top: 64px;
  }
`;

const BenefitItem = styled.div<BenefitItemContainer>`
  background: white;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  margin-bottom: 16px;
  flex-basis: 100%;
  justify-content: center;
  max-width: 380px;
  outline: ${({ selected, theme }) =>
    selected ? `1px solid ${theme.colors['borders-global-highlight']}` : 'none'};
  text-align: center;

  ${mq.tablet} {
    max-width: 352px;
    :nth-of-type(2n + 1) {
      margin-right: 16px;
    }
  }

  ${mq.desktop} {
    margin-right: 16px;
    max-width: 232px;
  }

  ${mq.desktopLarge} {
    max-width: 250px;
  }

  ${({ theme }) =>
    css`
      :hover {
        outline: 1px solid ${theme.colors.bluePrimary};
      }
    `}

  input,
  div {
    cursor: pointer;
  }
`;

const ItemWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 44px 12px 32px;
`;

const Icon = styled.div`
  height: 82px;
  padding-bottom: 16px;
`;

const Title = styled.div`
  font-size: 20px;
  font-weight: ${({ theme }) => theme.fontWeights['600']};
  line-height: 22px;
  padding: 0;
`;

const Description = styled.div`
  font-size: 16px;
  line-height: 20px;
  padding: 8px 0 32px;
`;

const RadioButton = styled.div`
  margin-top: auto;
`;

const ButtonBlock = styled.div`
  display: flex;
  justify-content: center;
`;

const Disclaimer = styled(Paragraph4)`
  ${({ theme }) =>
    css`
      color: ${theme.colors.grey4};
      margin-top: 16px;
      text-align: center;
    `}
`;

export default {
  PageWrapper,
  InfoBlock,
  PageTitle,
  PageDescription,
  BenefitsWrapper,
  BenefitItem,
  ItemWrapper,
  Icon,
  Title,
  Description,
  RadioButton,
  ButtonBlock,
  Disclaimer,
};
